import React from 'react';

const DataSummary = ({ formData, steps }) => {
  const formatKey = (key) => {
    return key.split(/(?=[A-Z])/).map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  };

  const getDisplayValue = (field, value) => {
    switch (field) {
      case 'binSizeId':
        return formData.binSize || value;
      case 'wasteTypeId':
        return formData.wasteType || value;
      default:
        return value;
    }
  };

  const hasData = steps.some(step => step.fields.some(field => formData[field]));

  if (!hasData) {
    return null;
  }

  return (
    <div className="bg-gray-100 p-4 rounded-lg shadow-md">
      {/* <h3 className="text-lg font-semibold mb-4 text-green-600">My Inform</h3> */}
      {steps.map((step, index) => {
        const stepData = step.fields.filter(field => formData[field]);
        if (stepData.length === 0) return null;

        return (
          <div key={index} className="mb-4">
            <h4 className="text-md font-medium text-gray-700 mb-2 pb-1 border-b border-gray-300">{step.title}</h4>
            <div className="space-y-2">
              {stepData.map(field => (
                <div key={field} className="flex flex-col">
                  <span className="text-sm font-medium text-gray-600">
                    {formatKey(field === 'binSizeId' ? 'binSize' : field === 'wasteTypeId' ? 'wasteType' : field)}
                  </span>
                  <span className="text-gray-800">{getDisplayValue(field, formData[field])}</span>
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default DataSummary;